import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { useCurrentCallback, useOnMount } from "abreact/utils/AbHooks";
import { AbSubscribeStore } from "abweb/collection/AbSubscribeStore";
import { AbstractUserSetting } from "abweb/service/settings/UserSetting";
import { BuiltInUserSettings } from "./BuiltInUserSettings";
export const BIG_FONT_TWEAK_THEME_CLASS_NAME = "ab-theme-tweak-large-font-size";
export let FontSizeSettings = /*#__PURE__*/function (FontSizeSettings) {
  FontSizeSettings["SMALLER"] = "smaller";
  FontSizeSettings["LARGER"] = "larger";
  return FontSizeSettings;
}({});
/**
 * Provides a way to react to the user setting font size change. Will invoke the given callback whenever
 * the value changes.
 * 
 * If you need to do this in a class component, just remember to remove the AbSubscribeStore callback
 * on unmount.
 */
export const useFontSizeUserSettingOnChange = onChange => {
  const currentOnChange = useCurrentCallback(onChange);
  useOnMount(() => {
    return BuiltInUserSettings.fontSize.subscribeStore.subscribe("onChange", currentOnChange);
  });
};

/**
 * A simple setting for managing the user's desired font size.
 */
export class FontSizeUserSetting extends AbstractUserSetting {
  constructor() {
    super("FontSize");
    _defineProperty(this, "defaultValue", FontSizeSettings.SMALLER);
    _defineProperty(this, "subscribeStore", new AbSubscribeStore());
  }
  async initialize() {
    const initialized = await super.initialize();
    if (initialized && this.value) {
      this.onValueChange(this.value);
    }
    return initialized;
  }
  get displayName() {
    return AbReactResources.userSetting_textSize_displayName();
  }
  get values() {
    return [{
      value: FontSizeSettings.SMALLER,
      displayName: AbReactResources.userSetting_textSize_smaller()
    }, {
      value: FontSizeSettings.LARGER,
      displayName: AbReactResources.userSetting_textSize_larger()
    }];
  }
  onValueChange(value) {
    if (value === FontSizeSettings.LARGER.valueOf()) {
      document.documentElement.classList.add(BIG_FONT_TWEAK_THEME_CLASS_NAME);
      this.subscribeStore.invoke("onChange", FontSizeSettings.LARGER);
    } else {
      document.documentElement.classList.remove(BIG_FONT_TWEAK_THEME_CLASS_NAME);
      this.subscribeStore.invoke("onChange", FontSizeSettings.SMALLER);
    }
  }
}
//# sourceMappingURL=FontSizeUserSetting.js.map
